import { Component, Input,  OnInit } from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators, SelectMultipleControlValueAccessor } from '@angular/forms';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientListDto } from 'src/app/core/models/entreprise/client-list-dto';
import { ClientService } from 'src/app/parametrage/core/service/client.service';
import { ClientItemDto } from 'src/app/core/models/entreprise/client-item-dto';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.css']
})
export class AddClientComponent implements OnInit {

  @Input() requestId;

  pressButton:Boolean = false;

  form: FormGroup;

  clients:ClientListDto = new ClientListDto();

  public clientList: FormArray;
  
  indexClient: Number = 0;

  get clientFormGroup() {
    return this.form.get('clients') as FormArray;
  }

  
  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _clientService: ClientService
  ) {
    this.createForm();
  }

  createForm() 
  {

    this.form = this.fb.group({
      clients:this.fb.array([this.createClient()])
    });

    this.clientList = this.form.get('clients') as FormArray;
  }

  

  createClient(): FormGroup {
    return this.fb.group({
      nomClient: [null, Validators.compose([Validators.required])]
    });
  }

  addClient() {
    this.clientList.push(this.createClient());
    var index = Number(this.indexClient);
    const newIndex = index + 1;
    this.indexClient = newIndex;
  }

  removeClient(index) {
    this.clientList.removeAt(index);
  }

  getClientsFormGroup(index): FormGroup {
    const formGroup = this.clientList.controls[index] as FormGroup;
    return formGroup;
  }


  ngOnInit() {
  }

  

  create(): void {
    
    this.pressButton = true;
    let clients = [];
    clients = this.creerListClients();
    this.clients.clientDtoList = clients;
    this.clients.requestId = this.requestId;
    this.spinner.show();

      this._clientService.addListClient(this.clients)
        .pipe(first())
                .subscribe(
                    data => {
                      this.spinner.hide();
                      this.activeModal.close();
                    },
                    error => {
                      console.log(error);
                      this.spinner.hide();
                });

  }

  creerListClients()
  {
    const clientItems:ClientItemDto[] = [];
    this.form.value.clients.forEach(function (value) {
      const client = new ClientItemDto();
      client.nomClient = value.nomClient;
      clientItems.push(client);
    });

    return clientItems;
  }









}
